import React from 'react'
import { ceil } from 'lodash'

import { Line, Area } from 'recharts'

import transform from '../transform'

import colors from 'lib/colors'
import ChartContainer from 'components/charts/container'
import { LAMBDA_MEMORY } from 'containers/inventory/details/resource/metrics-tabs/services/lambda'

const MemoryChart = ({ loading, data, height, span }) => {
  if (loading || !data) return null

  const metrics = transform({
    mem: data.INVOCATIONS_MEMORY
  }, value => ceil(value * 100))

  const formatted = metrics.map((metric) => {
    return {
      date: metric.date,
      [LAMBDA_MEMORY]: metric.mem_avg,
      diff: [metric.mem_min, metric.mem_max]
    }
  })

  const tooltipFormatter = (value, name, { dataKey }) => {
    if (dataKey === 'diff') return [`${value[0]} % - ${value[1]} %`, undefined]
    return [`${value}`, undefined]
  }

  return (
    <ChartContainer height={height}
      data={formatted}
      yTicksFormatting='0.[00]'
      span={span}
      tabKey={LAMBDA_MEMORY}
      formatTab={value => `${value}%`}
      formatTooltip={tooltipFormatter}
      percentageChart
    >
      <Line dataKey={LAMBDA_MEMORY} type='monotone' stroke={colors('chart', 'primary')} strokeWidth={1} unit='%' name='Average' dot={false} />
      <Area type='monotone' dataKey='diff' fill={colors('chart', 'primaryWithOpacity')} stroke={colors('chart', 'primaryWithOpacity')} strokeWidth='0.5' name='Min - max' />
    </ChartContainer>
  )
}

export default MemoryChart
